module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMS41NzYgNTQ3LjlsMjgyLjg0OCAxMjYuNDA0IDQwOS4yODUtMzgzLjI2IDEzNy4wNTctMTI4LjM0MUwzNjEuMjM0IDcxNC4yMmwzNjIuNzcgMTQ2LjM2MmM4Ljc0MiAzLjMyNyAxOC43MzMtMS4zMyAyMS44NTUtMTAuNjQ0di0uNjY2TDk5OS45ODUuMzc0IDEwLjMyNyA1MTQuNjM2Yy04Ljc0MiA0LjY1Ny0xMS44NjQgMTUuMzAyLTguMTE3IDI0LjYxNiAyLjQ5NyAzLjk5MSA1LjYyIDcuMzE4IDkuMzY2IDguNjQ4ek0zNjAuNjEgOTk5LjYyNmwxNDEuMTEyLTE2MS42NjMtMTQxLjExMi02MS4yMDZ2MjIyLjg2OXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/guide 2.svg
// module id = 517
// module chunks = 75